import MaterialTable from "@material-table/core";
import React, { forwardRef, useEffect, useState } from "react";
import { add_data, load_meta, load_data, update_data } from "./data_api";
import { Store } from 'react-notifications-component'
import { TextField } from "@mui/material";
import ModelAutoComplete from "./autocomplete";

function getEditComponent(type) {
  switch (type) {
    case 'text':
      return TextField
    // case 'date':
    //   return DatePicker
    case 'foreign_key':
      return ModelAutoComplete
    case 'textarea':
      return ({ onChange, ...props }) => (<TextField
        multiline
        onChange={(e) => onChange(e.target.value)}
        {...props} />)
    default:
      return undefined
  }
}

function DataTable(props, ref) {
  const modelName = props.modelName;
  const [firstload, setFirstload] = useState(true)

  const [columns, setColumns] = useState([])
  const [metainfo, setMetainfo] = useState({})

  var table_status = localStorage.getItem('table_status') || {}
  useEffect(() => {
    if (table_status[modelName] === undefined) {
      table_status = {
        ...localStorage.getItem('table_status') || {},
        [modelName]: {
          pageSize: 5,
          page: 0
        }
      }
      localStorage.setItem('table_status', table_status)
    }

    load_meta(props.modelName)
      .then(result => {
        let { columns, ...model_meta } = result.data
        setMetainfo(model_meta)
        setColumns(columns.map((column) => {
          let col = {
            editComponent: getEditComponent(column.type),
            ...column
          }
          // customize column display methods there
          if (column.type === 'foreign_key') {
            // it could happen that when old data is loaded / rendered with columns from a different model,
            // the foreign key column is not defined in the new model.
            // in this case, we need to set the foreign key column to be undefined 
            col.render = (rowData) => (rowData[column.field] || {})[column.auto_complete_config.name_field]
          }
          if (column.type === 'textarea') {
            col.render = (rowData) => (rowData[column.field] || '').substr(0, 50) + (rowData[column.field].length > 50 ? '...' : '')
          }
          return col
        }))
      })
      .catch(error_handler(() => { }))
  }, [props.modelName])

  // reload the table when columns changed
  useEffect(() => {
    ref.current.onQueryChange()
  }, [columns])

  const error_handler = call_back => e => {
    console.log("e=", e)
    Store.addNotification({
      title: "Error",
      message: (e.response && e.response.data),
      type: "danger",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    })
    call_back(e)
  }

  return (
    <MaterialTable
      tableRef={ref}
      title={props.title}
      columns={columns}
      data={query =>
        new Promise((resolve, reject) => {
          if (firstload && table_status[modelName] !== undefined) {
            // Overwrite Query param
            query = {
              ...query,
              ...table_status[modelName]
            }
            ref.current.onQueryChange(query)

            ref.current.dataManager.changePageSize(
              table_status[modelName].pageSize
            )
            setFirstload(false)
          }
          else if (!firstload) {
            table_status = {
              ...localStorage.getItem('table_status') || {},
              [modelName]: {
                ...table_status[modelName],
                ...query
              }
            }
            localStorage.setItem('table_status', table_status)
          }
          load_data(props.modelName, query)
            .then(result => {
              resolve({
                data: result.data.data,
                page: result.data.page,
                totalCount: result.data.total,
              })
            })
            .catch(error_handler(reject))
        })
      }
      detailPanel={props.detailPanel}
      options={{
        pageSize: 20,
        pageSizeOptions: [5, 20, 50, 100],
        actionsColumnIndex: -1,
        // paginationType: 'stepped'
        searchText: (table_status[modelName] !== undefined) ? table_status[modelName].search : null,
        filtering: true,
        selection: true
      }}

      localization={{
        // pagination: {
        //   labelDisplayedRows: '{from}-{to} of {count}'
        // },
        // toolbar: {
        //   nRowsSelected: '{0} row(s) selected'
        // },
        header: {
          actions: 'Operation'
        },
        // body: {
        //   emptyDataSourceMessage: 'No records to display',
        //   filterRow: {
        //     filterTooltip: 'Filter'
        //   }
        // }
      }}
      editable={{
        onRowAdd: newData => new Promise((resolve, reject) => {
          add_data(props.modelName, newData)
            .then(result => {
              resolve()
            })
            .catch(error_handler(reject))
        }),
        onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
          update_data(props.modelName, newData[metainfo.unique_identifier], newData)
            .then(result => {
              resolve()
            })
            .catch(error_handler(reject))
        }),
      }}
    />
  )
}

export default forwardRef(DataTable)